import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../../../../components/antd/card/CardContent";
import { CardTitle } from "../../../../../components/antd/card/CardTitle";
import { v4 as uuidv4 } from "uuid";
import { useCpFormValue } from "../../../../gvc/testNewForm/utils";
import { CpInput } from "../../../../gvc/testNewForm/CpInput";
import { CpFormItem } from "../../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../../../gvc/testNewForm/CpErrorWarning";
import { CpArrayObject } from "../../../../gvc/testNewForm/CpArrayObject";
import { CpArrayItemNameValuePair } from "../../../../workload/draft/CpArrayItemNameValuePair";
import { CpArrayItemTaint } from "../aws/CpArrayItemTaint";
import { CpErrorWarningArrayIcon } from "../../../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { NodePoolCoreButton } from "../nodePoolCoreButton";
import { NodePoolDetectedTags } from "../detectedTags";
import { NodePoolActionsDropdown } from "../NodePoolActionsDropdown";

interface Props {
  index: string;
}
export const LambdalabsUnmanagedNodePool: React.FC<Props> = ({ index }) => {
  const clusterName = useCpFormValue("name");
  const isCreate = useCpFormValue(`meta.isCreate`);
  const name = useCpFormValue(`lambdalabs.unmanagedNodePools.${index}.name`);
  const isDetailPage = !isCreate;

  return (
    <div className="cpln-form-section cpln-ant-tab-content">
      <Card>
        <CardTitle>
          <div className="flex justify-between items-center w-full">
            <span>
              Unmanaged Node Pool{name ? ` | ${name}` : ""}
              <CpErrorWarningArrayIcon names={[`lambdalabs.unmanagedNodePools`]} />
            </span>
            {isDetailPage && name && (
              <NodePoolActionsDropdown clusterName={clusterName} nodePoolName={name} poolType="Unmanaged Node Pool" />
            )}
          </div>
        </CardTitle>
        <CardContent>
          <div>
            <NodePoolDetectedTags name={`lambdalabs.unmanagedNodePools.${index}.labels`} />
            <CpFormItem>
              <CpLabel name={`lambdalabs.unmanagedNodePools.${index}.name`}>Name</CpLabel>
              <CpInput name={`lambdalabs.unmanagedNodePools.${index}.name`} style={{ width: 450 }} />
              <CpErrorWarning name={`lambdalabs.unmanagedNodePools.${index}.name`} />
            </CpFormItem>
            <div style={{ maxWidth: 900 }}>
              <CpFormItem>
                <div className="flex items-center gap-4">
                  <CpLabel name={`skip`}>Labels</CpLabel>
                  <NodePoolCoreButton name={`lambdalabs.unmanagedNodePools.${index}.labels`} />
                </div>
                <div className="-mt-2">
                  <CpArrayObject
                    factoryFn={() => ({ id: uuidv4(), name: "", value: "" })}
                    labels={["Name", "Value"]}
                    name={`lambdalabs.unmanagedNodePools.${index}.labels`}
                  >
                    <CpArrayItemNameValuePair />
                  </CpArrayObject>
                </div>
              </CpFormItem>
            </div>
            <div style={{ maxWidth: 900 }}>
              <CpArrayObject
                factoryFn={() => ({ id: uuidv4(), key: "", value: "", effect: "" })}
                labels={["Key", "Value", "Effect"]}
                label="Taints"
                name={`lambdalabs.unmanagedNodePools.${index}.taints`}
              >
                <CpArrayItemTaint />
              </CpArrayObject>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
